module.exports = __webpack_public_path__ + "static/media/linear.4f9c3f7d.svg";